import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, TrendingUp, DollarSign, PieChart } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-navy-900 text-white pt-16 pb-24 overflow-hidden" data-id="element-210">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-211">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-navy-800 rounded-full blur-3xl opacity-50" data-id="element-212"></div>
        <div className="absolute top-40 -left-20 w-72 h-72 bg-success/20 rounded-full blur-3xl opacity-30" data-id="element-213"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-214">
        <div className="flex flex-col lg:flex-row items-center gap-12 max-w-6xl mx-auto" data-id="element-215">
          <motion.div className="flex-1 text-center lg:text-left" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-216">
            <div className="inline-block bg-navy-800 border border-navy-700 text-success-light text-xs font-bold px-3 py-1 rounded-full mb-6 uppercase tracking-wider" data-id="element-217">
              🔥 Oferta Especial de Lanzamiento
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6" data-id="element-218">
              ¿Tenés un negocio, trabajás todo el día y aún así{' '}
              <span className="text-success" data-id="element-219">
                no sabés dónde se va tu dinero?
              </span>
            </h1>

            <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-220">
              El sistema práctico que ayuda a emprendedores y dueños de negocios
              a recuperar el control de sus finanzas, organizar sus números y
              transformar ingresos desordenados en ganancias reales.
            </p>

            <div className="flex flex-col sm:flex-row flex-wrap justify-center lg:justify-start gap-3 mb-8 text-sm md:text-base font-medium text-slate-200" data-id="element-221">
              <div className="flex items-center gap-2 bg-navy-800/50 px-3 py-2 rounded-lg border border-navy-700" data-id="element-222">
                <span className="text-success font-bold" data-id="element-223">
                  MÁS DE 15 RECURSOS INCLUIDOS
                </span>
              </div>
              <div className="flex items-center gap-2 bg-navy-800/50 px-3 py-2 rounded-lg border border-navy-700" data-id="element-224">
                <CheckCircle2 className="w-5 h-5 text-success" data-id="element-225" /> Método de 6
                Fases
              </div>
              <div className="flex items-center gap-2 bg-navy-800/50 px-3 py-2 rounded-lg border border-navy-700" data-id="element-226">
                <CheckCircle2 className="w-5 h-5 text-success" data-id="element-227" /> 6 Bonus
                Exclusivos
              </div>
              <div className="flex items-center gap-2 bg-navy-800/50 px-3 py-2 rounded-lg border border-navy-700" data-id="element-228">
                <CheckCircle2 className="w-5 h-5 text-success" data-id="element-229" /> 3 Bonus Plus
                Premium
              </div>
            </div>

            <div className="mb-8" data-id="element-230">
              <div className="flex items-center justify-center lg:justify-start gap-3 mb-2" data-id="element-231">
                <span className="text-slate-400 line-through text-xl font-medium" data-id="element-232">
                  $59.900 ARS
                </span>
                <span className="text-3xl md:text-4xl font-bold text-success" data-id="element-233">
                  Desde $19.990 ARS
                </span>
              </div>
            </div>

            <motion.a href="#pricing" className="inline-block w-full sm:w-auto bg-success hover:bg-success-hover text-white font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-[0_0_20px_rgba(16,185,129,0.4)] transition-all text-center" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-234">
              QUIERO RECUPERAR EL CONTROL DE MI DINERO
            </motion.a>

            <div className="mt-6 flex items-center justify-center lg:justify-start gap-2 text-sm text-slate-300" data-id="element-235">
              <div className="flex text-yellow-400" data-id="element-236">
                {'★★★★★'.split('').map((star, i) => <span key={i} data-id="element-237">{star}</span>)}
              </div>
              <span data-id="element-238">
                Más de 1.000 emprendedores ya comenzaron a tomar el control de
                sus finanzas.
              </span>
            </div>
          </motion.div>

          <motion.div className="flex-1 w-full max-w-md lg:max-w-none relative" initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-239">
            {/* Abstract Dashboard Mockup */}
            <div className="bg-navy-800 border border-navy-700 rounded-2xl p-6 shadow-2xl relative" data-id="element-240">
              <div className="flex items-center justify-between mb-6 border-b border-navy-700 pb-4" data-id="element-241">
                <div className="flex gap-2" data-id="element-242">
                  <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-243"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-244"></div>
                  <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-245"></div>
                </div>
                <div className="text-slate-400 text-sm font-medium" data-id="element-246">
                  Panel Financiero
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-247">
                <div className="bg-navy-900 rounded-xl p-4 border border-navy-700" data-id="element-248">
                  <div className="text-slate-400 text-xs mb-1 flex items-center gap-1" data-id="element-249">
                    <DollarSign className="w-3 h-3" data-id="element-250" /> Ingresos
                  </div>
                  <div className="text-xl font-bold text-white" data-id="element-251">$450.000</div>
                  <div className="text-success text-xs mt-1 flex items-center gap-1" data-id="element-252">
                    <TrendingUp className="w-3 h-3" data-id="element-253" /> +12%
                  </div>
                </div>
                <div className="bg-navy-900 rounded-xl p-4 border border-navy-700" data-id="element-254">
                  <div className="text-slate-400 text-xs mb-1 flex items-center gap-1" data-id="element-255">
                    <PieChart className="w-3 h-3" data-id="element-256" /> Ganancia Neta
                  </div>
                  <div className="text-xl font-bold text-success" data-id="element-257">$185.000</div>
                  <div className="text-success text-xs mt-1 flex items-center gap-1" data-id="element-258">
                    <TrendingUp className="w-3 h-3" data-id="element-259" /> +8%
                  </div>
                </div>
              </div>

              <div className="bg-navy-900 rounded-xl p-4 border border-navy-700 h-40 flex items-end gap-2 justify-between pt-8" data-id="element-260">
                {[40, 70, 45, 90, 65, 100, 85].map((height, i) => <motion.div key={i} className="w-full bg-success/80 rounded-t-sm" initial={{
                height: 0
              }} animate={{
                height: `${height}%`
              }} transition={{
                duration: 1,
                delay: 0.5 + i * 0.1
              }} data-id="element-261"></motion.div>)}
              </div>

              {/* Floating element */}
              <motion.div className="absolute -right-6 -bottom-6 bg-white text-navy-900 p-4 rounded-xl shadow-xl border border-slate-100 flex items-center gap-4" animate={{
              y: [0, -10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 4,
              ease: 'easeInOut'
            }} data-id="element-262">
                <div className="bg-success/20 p-2 rounded-full" data-id="element-263">
                  <CheckCircle2 className="w-6 h-6 text-success" data-id="element-264" />
                </div>
                <div data-id="element-265">
                  <div className="text-xs font-bold text-slate-500 uppercase" data-id="element-266">
                    Estado
                  </div>
                  <div className="font-bold text-sm" data-id="element-267">Finanzas Organizadas</div>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}